import { SxStyles } from '../../types';
import theme from '../../theme';
import { getResponsiveSize } from '../../utils';

export const ControlPanelSessionTabStyles: SxStyles = {
  controlPanelSessionTab: {
    '& .general-score-container': {
      width: '100%',
    },
    '.notes-container': {
      '.textarea': {
        width: '100%',
        padding: '10px',
        fontSize: '14px',
        fontFamily: theme.typography.fontFamily,
      },
      '.save-notification': {
        marginTop: '10px',
        fontSize: '12px',
        color: theme.palette.success.main,
      },
    },
  },
};
